<template>
  <div class="animated fadeIn page-shell">
    <HeaderPadrao class="mb-2" icon="fa fa-list-alt" titulo="ORDEM DE ABATE">
      <template #subtitulo>
        <i class="fa fa-tag mr-1 text-info"></i>
        Lote: <strong class="text-white">{{ registro.LOTE || 'Novo' }}</strong>
        <span class="mx-2">•</span>
        <i class="fa fa-calendar mr-1 text-info"></i>
        Data: <strong class="text-white">{{ registro.DT_LOTE ? moment(registro.DT_LOTE).format('DD/MM/YYYY') : '---' }}</strong>
      </template>

      <template #acoes>
        <b-button v-if="exibirBotaoAlterar" variant="link" class="btn-glass btn-glass-warning" @click.stop.prevent="onGravarEditar()">
          <i class="fa fa-save mr-1"></i> GRAVAR ALTERAÇÕES
        </b-button>

        <b-button v-if="exibirBotaoGravar" variant="link" class="btn-glass btn-glass-success" @click.stop.prevent="onGravarNovo()">
          <i class="fa fa-save mr-1"></i> GRAVAR
        </b-button>

        <b-button variant="light" pill class="ml-2 font-weight-bold shadow-sm" @click.stop.prevent="onVoltarPrincipal()">
          <i class="fa fa-arrow-left mr-1"></i> Voltar
        </b-button>
      </template>
    </HeaderPadrao>

    <div class="page-main px-3">
      <div style="max-height: 85vh; overflow-y: auto; overflow-x: hidden;" class="pr-2 pb-5">
        <!-- Main Summary Bar -->
        <b-row class="mb-4 mt-2">
          <b-col md="3">
            <div class="stat-item bg-white p-3 rounded shadow-sm text-center transition-hover h-100 border-top border-info" style="border-top-width: 3px !important;">
              <small class="modal-label-premium d-block text-muted">ID / Lote</small>
              <h4 class="mb-0 font-weight-bold text-dark">{{registro.ID || '---'}} / {{registro.LOTE || '---'}}</h4>
            </div>
          </b-col>
          <b-col md="3">
            <div class="stat-item bg-white p-3 rounded shadow-sm text-center transition-hover h-100 border-top border-primary" style="border-top-width: 3px !important;">
              <small class="modal-label-premium d-block text-muted">Data Emissão</small>
              <h4 class="mb-0 font-weight-bold text-dark">{{registro.DT_LANCAMENTO ? moment(registro.DT_LANCAMENTO).format('DD/MM/YYYY') : '---'}}</h4>
            </div>
          </b-col>
          <b-col md="3">
            <div class="stat-item bg-white p-3 rounded shadow-sm text-center transition-hover h-100 border-top border-warning" style="border-top-width: 3px !important;">
              <small class="modal-label-premium d-block text-muted">Situação</small>
              <h4 class="mb-0 font-weight-bold text-dark">{{traduzStatus}}</h4>
            </div>
          </b-col>
          <b-col md="3">
            <div class="stat-item bg-white p-3 rounded shadow-sm text-center transition-hover h-100 border-top border-success" style="border-top-width: 3px !important;">
              <small class="modal-label-premium d-block text-muted">TOTAL ANIMAIS</small>
              <h2 class="mb-0 font-weight-bold text-dark">{{tabelaAnimais.items.length}}</h2>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="7">
            <!-- Identificação Básica -->
            <b-card no-body class="border-0 shadow-sm mb-4 rounded-lg">
              <div class="card-header bg-white border-bottom-0 py-3">
                <h5 class="mb-0 text-primary font-weight-bold">
                  <i class='fa fa-info-circle mr-2'></i>Identificação Básica
                </h5>
              </div>
              <b-card-body class="pt-0">
                <b-row>
                  <b-col md="4">
                    <b-form-group label="Data do Lote" label-class="modal-label-premium">
                      <cec-input-data v-model="registro.DT_LOTE" :state="registro.DT_LOTE != null" class="rounded-pill shadow-xs" />
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group label="Hora da Entrada" label-class="modal-label-premium">
                      <b-form-input type="time" v-model="registro.HORA_ENT" :state="registro.HORA_ENT != null" class="rounded-pill shadow-xs"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group label="GTA" label-class="modal-label-premium">
                      <b-form-input type="text" v-model="registro.GTA" placeholder="Número do GTA" :state="registro.GTA != null" class="rounded-pill shadow-xs"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="6">
                    <b-form-group label="Tipo de Ordem" label-class="modal-label-premium">
                      <b-form-select v-model="registro.VINCULA_COMPRA_GADO" :options="tipoOrdem" :state="registro.VINCULA_COMPRA_GADO != null" class="rounded-pill shadow-xs"></b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group label="Tipo de Processo" label-class="modal-label-premium">
                      <b-form-select v-model="registro.OP_TIPO_SERVICO" :options="tipoServico" :state="registro.OP_TIPO_SERVICO != null" :disabled="registro.STATUS != '1'" class="rounded-pill shadow-xs"></b-form-select>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
            <!-- Interessados -->
            <b-card no-body class="border-0 shadow-sm mb-4 rounded-lg">
              <div class="card-header bg-white border-bottom-0 py-3">
                <h5 class="mb-0 text-primary font-weight-bold">
                  <i class='fa fa-users mr-2'></i>Interessados e Logística
                </h5>
              </div>
              <b-card-body class="pt-0">
                <b-row>
                  <b-col md="12">
                    <cliente-pesquisa 
                      @retornaId="registro.CLIENTE_ID = $event"
                      :idInicial="registro.CLIENTE_ID"
                      :classe-required="registro.CLIENTE_ID == null"
                      :desabilitarInput="desabilitado"
                      id="edCLIENTE_ID"
                      idModal="modalCliente"
                      label="Fornecedor"
                      place="Informe o Fornecedor"
                      :arredondado="true"
                      labelBotao=""
                      ref="pesquisaFornecedor">
                    </cliente-pesquisa>
                  </b-col>
                </b-row>
                <b-row class="mt-2">
                  <b-col md="12">
                    <cliente-pesquisa 
                      @retornaId="registro.MARCHANT_ID = $event"
                      :idInicial="registro.MARCHANT_ID"
                      :classe-required="registro.MARCHANT_ID == null"
                      :desabilitarInput="desabilitado"
                      idModal="modalMarchant"
                      label="Marchante"
                      id="edMARCHANT_ID"
                      place="Informe o Marchant"
                      :arredondado="true"
                      labelBotao=""
                      ref="pesquisaMarchante">
                    </cliente-pesquisa>
                  </b-col>
                </b-row>
                <b-row class="mt-2">
                  <b-col md="12">
                    <cliente-pesquisa 
                      @retornaId="registro.FAZENDA_ID = $event"
                      :idInicial="registro.FAZENDA_ID"
                      :classe-required="registro.FAZENDA_ID == null"
                      :desabilitarInput="desabilitado"
                      idModal="modalFazenda"
                      label="Fazenda"
                      id="edFAZENDA_ID"
                      place="Informe a Fazenda"
                      :arredondado="true"
                      labelBotao=""
                      ref="pesquisaFazenda">
                    </cliente-pesquisa>
                  </b-col>
                </b-row>
                <b-row class="mt-2">
                  <b-col md="12">
                    <b-form-group label="Responsável" label-class="modal-label-premium">
                      <FuncionarioDropdown 
                        v-model="registro.BALANCEIRO_ID"
                        :state="registro.BALANCEIRO_ID != null"
                        placeholder="Selecione o Responsável"
                        class="rounded-pill shadow-xs"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="mt-2">
                  <b-col md="6">
                    <b-form-group label="Estoque de Origem" label-class="modal-label-premium">
                      <CentroEstoqueDropDown 
                        v-model="registro.CENTRO_ESTOQUE_ORIGEM_ID"
                        :state="registro.CENTRO_ESTOQUE_ORIGEM_ID != null"
                        placeholder="Estoque Origem"
                        class="rounded-pill shadow-xs"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group label="Estoque de Destino" label-class="modal-label-premium">
                      <CentroEstoqueDropDown 
                        v-model="registro.CENTRO_ESTOQUE_ID"
                        :disabled="true"
                        :state="registro.CENTRO_ESTOQUE_ID != null"
                        placeholder="Estoque Destino"
                        class="rounded-pill shadow-xs"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="mt-2">
                  <b-col md="6">
                    <b-form-group label="Custo Operacional" label-class="modal-label-premium">
                      <CustoOperacionalDropDown 
                        v-model="registro.CUSTO_OPERACIONAL_ID"
                        :state="registro.CUSTO_OPERACIONAL_ID != null"
                        placeholder="Custo Operacional"
                        class="rounded-pill shadow-xs"
                        :dropup="true"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group label="Custo Operacional KG/R$" label-class="modal-label-premium">
                      <vue-autonumeric v-model="registro.VL_CUSTO_OPERACIONAL" :options="'Brazilian'" class="form-control rounded-pill shadow-xs text-right font-weight-bold"></vue-autonumeric>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-col>  
          <b-col lg="5">
            <!-- Animais do Lote -->
            <b-card no-body class="border-0 shadow-sm mb-4 rounded-lg overflow-hidden">
              <div class="card-header bg-white border-bottom-0 py-3 d-flex justify-content-between align-items-center">
                <h5 class="mb-0 text-primary font-weight-bold">
                  <i class='fa fa-paw mr-2'></i>Animais do Lote
                </h5>
                <b-button v-if="registro.ID < 1" variant="success" pill size="sm" class="shadow-sm font-weight-bold" @click.stop.prevent="onIniciarCadastramento()">
                  <i class="fa fa-plus mr-1"></i> Incluir Animal
                </b-button>
                <b-button v-else variant="success" pill size="sm" class="shadow-sm font-weight-bold" @click.stop.prevent="onAbrirModalAnimalNovo()">
                  <i class="fa fa-plus mr-1"></i> Incluir Animal
                </b-button>
              </div>
              <b-card-body class="p-0">
                <b-table 
                  class="modern-premium-table mb-0" 
                  hover 
                  responsive
                  :items="tabelaAnimais.items" 
                  :fields="tabelaAnimais.fields"
                  show-empty
                  empty-text="Nenhum animal vinculado ao lote"
                >
                  <template #cell(actions)="item">
                    <div class="d-flex gap-1 justify-content-end">
                      <b-button type="button" @click="onAbrirModalAnimalEditar(item.item.ID)" size="sm" variant="soft-info" pill class="btn-icon-only shadow-sm" title="Alterar Animal" v-b-tooltip.hover>
                        <i class="fa fa-edit"></i>
                      </b-button>
                      <b-button type="button" @click="onDeleteAnimal(item.item)" size="sm" variant="soft-danger" pill class="btn-icon-only shadow-sm" title="Remover Animal" v-b-tooltip.hover>
                        <i class="fa fa-trash"></i>
                      </b-button>
                    </div>
                  </template>
                </b-table>
              </b-card-body>
            </b-card>
          </b-col>  
        </b-row>  
      </div>
    </div>
    
    <!--/.row-->
    
    <!-- Modal Animal Modernizado -->
    <b-modal ref="modal-animal" 
        id="modal-animal" 
        hide-header
        hide-footer
        centered
        size="lg"
        body-class="p-0 overflow-hidden"
        content-class="border-0 shadow-lg"
        @shown="focusModalAnimal()" 
    >
      <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;">
          <div class="header-icon-wrapper mr-3 bg-white-10">
              <i class="fa fa-paw text-white"></i>
          </div>
          <div>
              <h5 class="mb-0 font-weight-bold text-white">{{ animal.ID == null ? 'Cadastrar Animal' : 'Alterar Animal' }}</h5>
              <small class="text-white opacity-75">Informações técnicas do animal para o lote</small>
          </div>
          <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-animal')">
              <i class="fa fa-times fa-lg"></i>
          </b-button>
      </div>

      <div class="p-4 bg-white">
          <b-row>
            <b-col sm="12">
              <b-form-group label="Animal" label-class="modal-label-premium">
                <ProdutoAnimalDropDown 
                  v-model="animal.PRODUTO_ID"
                  :state="animal.PRODUTO_ID != null"
                  :disabled="animal.ID != null"
                  placeholder="Selecione o Animal"
                  class="rounded-pill shadow-xs"
                  ref="edPRODUTO_ID"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col sm="4">
              <b-form-group label="Raça" label-class="modal-label-premium">
                <b-form-select v-model="animal.ANIMAL_RACA_ID" :options="optionsRaca" class="rounded-pill shadow-xs">
                  <template slot="first">
                    <option :value="null">Não Informado</option>
                  </template>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group label="Cor Predominante" label-class="modal-label-premium">
                <b-form-select v-model="animal.ANIMAL_COR_ID" :options="optionsCor" class="rounded-pill shadow-xs">
                  <template slot="first">
                    <option :value="null">Não Informado</option>
                  </template>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group label="Sexo" label-class="modal-label-premium">
                <b-form-select v-model="animal.OP_SEXO" :options="optionsSexo" class="rounded-pill shadow-xs">
                  <template slot="first">
                    <option :value="null">Não Informado</option>
                  </template>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col md="4">
                    <b-form-group label="Curral" label-class="modal-label-premium">
                      <b-form-input type="text" v-model="animal.CURRAL" placeholder="Número do Curral" :state="!!animal.CURRAL" class="rounded-pill shadow-xs"></b-form-input>
                    </b-form-group>
                  </b-col>
            <b-col sm="4">
              <b-form-group label="Quantidade" label-class="modal-label-premium">
                <vue-autonumeric v-model="animal.QUANT" ref="edQUANT" class="form-control rounded-pill shadow-xs text-right font-weight-bold" :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', roundingMethod: 'U', minimumValue: '0' }" :class="{'is-valid' : animal.QUANT > 0}"></vue-autonumeric>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group label="Cabeças" label-class="modal-label-premium">
                <vue-autonumeric v-model="animal.PECAS" class="form-control rounded-pill shadow-xs text-right font-weight-bold" :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', decimalPlaces: '0', roundingMethod: 'U', minimumValue: '0' }" :class="{'is-valid' : animal.PECAS > 0, 'is-invalid' : animal.PECAS <= 0}"></vue-autonumeric>
              </b-form-group>
            </b-col>
          </b-row>
      </div>

      <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-end">
        <b-button v-if="animal.ID == null" variant="success" pill class="px-4 font-weight-bold mr-2" @click="onPostAnimalNovo()">
          <i class="fa fa-check mr-1"></i> GRAVAR
        </b-button>
        <b-button v-else variant="success" pill class="px-4 font-weight-bold mr-2" @click="onPostAnimalAlterar()">
          <i class="fa fa-save mr-1"></i> GRAVAR ALTERAÇÃO
        </b-button>
        <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="$bvModal.hide('modal-animal')">
          <i class="fa fa-times mr-1"></i> FECHAR
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import VueButtonSpinner from '../../../components/VueButtonSpinner.vue'
import FuncionarioDropdown from '../../componentes/dropdown/FuncionarioDropdown.vue'
import CentroEstoqueDropDown from '../../componentes/dropdown/CentroEstoqueDropDown.vue'
import CustoOperacionalDropDown from '../../componentes/dropdown/CustoOperacionalDropDown.vue'
import ClientePesquisa from '../../pesquisa/ClientePesquisa.vue'
import ProdutoAnimalDropDown from '../../componentes/dropdown/ProdutoAnimalDropDown.vue'
import HeaderPadrao from '@/components/Cec/HeaderPadrao.vue'
import CecInputData from '@/components/Cec/CecInputData.vue'
import moment from 'moment'
import VueAutonumeric from 'vue-autonumeric'

export default {
  components: {
    VueButtonSpinner,
    FuncionarioDropdown,
    CentroEstoqueDropDown,
    CustoOperacionalDropDown,
    ClientePesquisa,
    ProdutoAnimalDropDown,
    HeaderPadrao,
    CecInputData,
    VueAutonumeric
  },
  data () {
    return {
      moment: moment,
      desabilitado: true,
      isLoading: false,
      status: '',
      submmited: false,
      monitoraAlteracao: false,
      registroMonitoramento: [],
      itensForamAlterados: false,
      registro: {
            ID                        : null,
            BALANCEIRO_ID             : null,
            COMPRADOR_ID              : null,
            CLIENTE_ID                : null,
            LOTE                      : null,
            DT_LOTE                   : null,
            DT_LANCAMENTO             : null,
            USUARIO                   : null,
            DT_ALTERACAO              : null,
            USUARIO_ALTERACAO         : null,
            VL_EMBARQUE               : null,
            OBS                       : null,
            HORA_ENT                  : null,
            STATUS                    : null,
            CIDADE                    : null,
            CENTRO_ESTOQUE_ID         : null,
            MARCHANT_ID               : null,
            FAZENDA_ID                : null,
            VACA                      : null,
            NOVILHA                   : null,
            BOI                       : null,
            TOURO                     : null,
            BOI_INTEIRO               : null,
            BOI_CAPAO                 : null,
            BUFALO_MACHO              : null,
            BUFALO_FEMEA              : null,
            CUSTO_OPERACIONAL_ID      : null,
            HORA_SAI                  : null,
            OP_FECHADO_EXPEDICAO      : null,
            GTA                       : null,
            DATA_GTA                  : null,
            MINUTA                    : null,
            CENTRO_ESTOQUE_ORIGEM_ID  : null,
            COMPRA_GADO_ID            : null,
            VL_CUSTO_VACA             : null,
            VL_CUSTO_NOVILHA          : null,
            VL_CUSTO_TOURO            : null,
            VL_CUSTO_BUFALO_MACHO     : null,
            VL_CUSTO_BUFALO_FEMEA     : null,
            VL_CUSTO_BOI_INTEIRO      : null,
            VL_SERVICO_CABECA         : null,
            VL_CUSTO_OPERACIONAL      : 0.00,
            VL_CUSTO_BOI              : null,
            DT_VENCIMENTO_ARECEBER    : null,
            DT_VENCIMENTO_APAGAR      : null,
            OP_CREDOR                 : null,
            OP_DEVEDOR                : null,
            VL_UNT_RESERVA            : null,
            VL_TOTAL_RESERVA          : null,
            VL_TOTAL_SERVICO          : null,
            CENTRO_CUSTO_APAGAR_ID    : null,
            CENTRO_CUSTO_ARECEBER_ID  : null,
            HISTORICO_ARECEBER_ID     : null,
            HISTORICO_APAGAR_ID       : null,
            NR_CABECAS                : null,
            NR_CABECAS_RESERVA        : null,
            QUANT_RESERVA             : null,
            VINCULA_COMPRA_GADO       : null,
            OP_TIPO_SERVICO           : null,
            OP_FECHADO_DIARIO         : null,
            OBS_PLANO_EXPEDICAO       : null,
            DT_PREVISAO_EXPEDICAO     : null,
      },
      animal: {
        ID : null,
        ABATE_ID: null,
        PRODUTO_ID: null,
        ANIMAL_RACA_ID: null,
        CLASSIFICACAO_ID: null,
        CLASSIFICACAO_FAIXA: null,
        ANIMAL: null,
        OP_SEXO: null,
        PECAS: 0.00,
        QUANT: 0.00,
        VL_UNT: 0.00,
        TX_PRODUTO: null,
        CENTRO_ESTOQUE_ID: null,
        CURRAL: null,
        VL_TOTAL: 0.00,
        ANIMAL_COR_ID: null,
      },
      tipoOrdem: [
        {value: '0', text: '0 - ORDEM NÃO VINCULADA A COMPRA DE GADO'},
        {value: '1', text: '1 - ORDEM VINCULADA A COMPRA DE GADO'}
      ],
      tipoServico: [
        {value: '1', text: '1 - PRÓPRIO'},
        {value: '2', text: '2 - SERVIÇO'}
      ],
      tabelaAnimais: {
        fields: [
          {
            key: "NOME_PRODUTO",
            label: 'Animal'
          },
          {
            key: "CENTRO_ESTOQUE_ID",
            label: 'Estoque Origem'
          },
          {
            key: 'QUANT', 
            class:'text-right', 
            label: 'Peso (KG)', 
            formatter: (value, key, item) => 
            value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : (0.00).toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3})
          },
          {
            key: "PECAS",
            label: 'Cabeças'
          },
          {
            key: "actions" ,
            label: 'Ações',
            class:'text-right',
            thStyle: { width: "20%" }
          }
        ],
        items: []
      },
         
      optionsRaca: [],
      optionsCor: [],
      optionsSexo: [
       {value: 'M', text: 'MACHO'},
       {value: 'F', text: 'FEMEA'}
      ]
      
    }
  },
  methods: {
    isValid() {
      return     this.registro.DT_LOTE 
              && this.registro.HORA_ENT
              && this.registro.CLIENTE_ID
              && this.registro.MARCHANT_ID
              && this.registro.FAZENDA_ID
              && this.registro.BALANCEIRO_ID
              && this.registro.OP_TIPO_SERVICO
    },
    isValidaAnimal() {
      return     this.animal.PRODUTO_ID
              && this.animal.PECAS
              && this.animal.CURRAL
    },
    async onVoltarPrincipal() {
      try {
        this.$store.commit('controle/setAguardando', true)
        try {
          await this.$store.dispatch('ordemAbate/GERAR_LISTA')
          this.$store.commit("abateResumo/SET_REGISTRO_SELECIONADO_ID", this.registro.ID?? 0)
          
          return
        } catch(err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', `Não foi possível atualizar a Lista de Ordens de Abate \n Tente Filtrar Manualmente!!!` )
        }
      } finally {
        this.$store.commit('controle/setAguardando', false)
        this.$router.push(`/producao/ordemabate/listagem`)
      }
      
    },
    onAbrirModalAnimalNovo() {
      this.criarListasAnimal()
      this.limparObjeto(this.animal)
      this.animal.PECAS = 0.00
      this.animal.QUANT = 0.00
      this.animal.VL_UNT = 0.00
      this.animal.VL_TOTAL = 0.00

      this.$refs['modal-animal'].show()
    },
    async onAbrirModalAnimalEditar(id) {
      await this.criarListasAnimal()
      this.$http.get(`/api/protected/abate/animal/getById/${id}`)
      .then(result => {
        if (result.data.length === 0 ) {
          this.$root.$bvToast.toast(`Cadastro do Animal não encontrado. Volte a tela de pesquisa!!!`, {
            title: 'Aviso',
            autoHideDelay: 2000,
            variant: 'warning',
            appendToast: true
          })
          return
        }
      
        this.animal =  result.data[0]

        this.$refs['modal-animal'].show()
      })
      .catch( err => {
        this.$root.$bvToast.toast(`Falha ao localiza o animal ${err}` , {
            title: 'Aviso',
            autoHideDelay: 2000,
            variant: 'danger',
            appendToast: true
          })
      })
    },
    
    focusModalAnimal (){
      if (this.animal.ID) {
        this.$refs.edQUANT.$refs.autoNumericElement.focus()
      } else {
        if (this.$refs.edPRODUTO_ID && this.$refs.edPRODUTO_ID.$refs.input) {
          this.$refs.edPRODUTO_ID.$refs.input.focus()
        }
      }
    },
    async onPostAnimalNovo () {
      if (!this.isValidaAnimal()) {
        this.$root.$bvToast.toast(`Preencha todos os campos obrigatórios!!!`, {
          title: 'Aviso',
          autoHideDelay: 2000,
          variant: 'warning',
          appendToast: true
        })
        return
      } else {
        this.$store.commit('controle/setAguardando', true)   
        
        if (await this.gravarAnimalNovo() == true) {
          if (await this.atualizarListaAnimal() == true) {
            let abate = await this.getRegistroById(this.registro.ID)
            
            if ( abate.data.length !== 0) {
              this.registro.STATUS = abate.data.STATUS
              this.$refs['modal-animal'].hide()
              this.$store.commit('controle/setAguardando', false)
            } else {
              this.$store.commit('controle/setAguardando', false)   
            }
          } else {
            this.$store.commit('controle/setAguardando', false)   
          }
        } else {
          this.$store.commit('controle/setAguardando', false)   
        }
      } 
    },
    gravarAnimalNovo () {
      this.animal.ABATE_ID = this.registro.ID
      this.animal.CENTRO_ESTOQUE_ID = this.registro.CENTRO_ESTOQUE_ORIGEM_ID
      return new Promise(resolve => {
        this.$http.post(`/api/protected/abate/animal/post`, this.animal)
        .then(() =>{
          this.itensForamAlterados = true
          resolve(true)
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          if (erro.response.status == 400) {
            this.toastCount++
            this.$root.$bvToast.toast(`Atenção: ${erro.response.data}`, {
              title: 'Atenção',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          }
          resolve(false)
        })
      })
    },
    async onPostAnimalAlterar () {
      if (!this.isValidaAnimal()) {
        this.$root.$bvToast.toast(`Preencha todos os campos obrigatórios!!!`, {
          title: 'Aviso',
          autoHideDelay: 2000,
          variant: 'warning',
          appendToast: true
        })
        return
      } else {
        this.$store.commit('controle/setAguardando', true)   
        
        if (await this.gravarAnimalAlterar() == true) {
          if (await this.atualizarListaAnimal() == true) {
            let abate = await this.getRegistroById(this.registro.ID)
            
            if ( abate.data.length !== 0) {
              this.registro.STATUS = abate.data.STATUS
              this.$refs['modal-animal'].hide()
              this.$store.commit('controle/setAguardando', false)
            } else {
              this.$store.commit('controle/setAguardando', false)   
            }
          } else {
            this.$store.commit('controle/setAguardando', false)   
          }
        } else {
          this.$store.commit('controle/setAguardando', false)   
        }
      } 
    },
    gravarAnimalAlterar () {
      return new Promise(resolve => {
        this.$http.post(`/api/protected/abate/animal/edit`, this.animal)
        .then(() =>{
          this.itensForamAlterados = true
          resolve(true)
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          if (erro.response.status == 400) {
            this.toastCount++
            this.$root.$bvToast.toast(`Atenção: ${erro.response.data}`, {
              title: 'Atenção',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          }
          resolve(false)
        })
      })
    },
    atualizarListaAnimal () {
      return new Promise(resolve => {
        this.$http.get(`/api/protected/producao/getAnimalListagemByAbateId/${this.registro.ID}`)
        .then(result =>{
          this.tabelaAnimais.items = result.data
          resolve(true)
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          if (erro.response.status == 400) {
            this.toastCount++
            this.$root.$bvToast.toast(`Falha: ${erro.response.data}`, {
              title: 'Falha',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          }
          resolve(false)
        })
      })
    },
    async onDeleteAnimal (item) {
      const confirmar = await this.$bvModal.msgBoxConfirm('Deseja realmente excluir este animal?', {
        title: 'Confirmação',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'SIM',
        cancelTitle: 'NÃO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })

      if (!confirmar) return

      this.$store.commit('controle/setAguardando', true)   
      if (await this.excluirAnimal(item) == true) {
        if (await this.atualizarListaAnimal() == true) {
          let abate = await this.getRegistroById(this.registro.ID)
          
          if ( abate.data.length !== 0) {
            this.registro.STATUS = abate.data.STATUS
            this.$refs['modal-animal'].hide()
            this.$store.commit('controle/setAguardando', false)
          } else {
            this.$store.commit('controle/setAguardando', false)   
          }
        } else {
          this.$store.commit('controle/setAguardando', false)   
          return
        }
      } else {
        this.$store.commit('controle/setAguardando', false)   
        return
      }

      this.$store.commit('controle/setAguardando', false)

      this.toastCount++
      this.$root.$bvToast.toast(`Animal removido da lista de Ordem de Abate`, {
        title: 'Atenção',
        autoHideDelay: 3000,
        variant: 'success',
        appendToast: true
      })
      this.itensForamAlterados = true
      
    },
    excluirAnimal (item) {
      
      return new Promise(resolve => {
        this.$http.post(`/api/protected/abate/animal/delete/${item.ID}`)
        .then(() =>{
          resolve(true)
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          if (erro.response.status == 400) {
            this.toastCount++
            this.$root.$bvToast.toast(`Atenção: ${erro.response.data}`, {
              title: 'Atenção',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          }
          resolve(false)
        })
      })
    },
    onGravarNovo () {
      if (!this.isValid()) {
        this.$root.$bvToast.toast(`Preencha todos os campos obrigatórios!!!`, {
          title: 'Aviso',
          autoHideDelay: 2000,
          variant: 'danger',
          appendToast: true
        })
        
        return
      }
      
      this.$store.commit('controle/setAguardando', true)    

      if (this.tabelaAnimais.items && this.tabelaAnimais.items.length > 0 ) {
        this.registro.STATUS = '2' // Planejamento Iniciado
      } else {
        this.registro.STATUS = '1' //lancamentos principais
      }
      
      this.$http.post(`/api/protected/producao/post`, this.registro)
      .then(() => {
        this.$router.push(`/producao/ordemabate/listagem`)
        this.$store.commit('controle/setAguardando', false)
        this.toastCount++
        this.$root.$bvToast.toast(`Ordem de Abate Gravada com Sucesso!!!`, {
          title: 'Aviso',
          autoHideDelay: 3000,
          variant: 'success',
          appendToast: true
        })
        
      })
      .catch(erro => {
        this.$store.commit('controle/setAguardando', false)
        if (erro.response.status == 400) {
          this.toastCount++
          this.$root.$bvToast.toast(`Atenção: ${erro.response.data}`, {
            title: 'Atenção',
            autoHideDelay: 3000,
            variant: 'warning',
            appendToast: true
          })
        }
      })
    },
    onGravarEditar () {
      if (!this.isValid()) {
        this.$root.$bvToast.toast(`Preencha todos os campos obrigatórios!!!`, {
          title: 'Aviso',
          autoHideDelay: 2000,
          variant: 'danger',
          appendToast: true
        })
        
        return
      }

      //Em alteracao so deve ir para pronto para coleta se estiver em lancamentos principais ou planejamento iniciado e tiver animais
      if (this.tabelaAnimais.items && this.tabelaAnimais.items.length > 0 ) {
        //'1' - lancamentos principais  '2' - Planejamento Iniciado
        if (['1','2'].includes(this.registro.STATUS)   ) {
          this.registro.STATUS = '3' // Pronto para Coleta
        }
        
      }
      
      this.$store.commit('controle/setAguardando', true)    
      this.$http.post(`/api/protected/producao/edit`, this.registro)
      .then(() => {
        
        this.$store.dispatch('ordemAbate/GERAR_LISTA')
        .then(() => {
          this.$store.commit('controle/setAguardando', false)
          this.toastCount++
          this.$root.$bvToast.toast(`ALTERAÇÕES gravadas com Sucesso!!!`, {
            title: 'Aviso',
            autoHideDelay: 3000,
            variant: 'success',
            appendToast: true
          })
          this.$router.push(`/producao/ordemabate/listagem`)
          return
        }).catch((error) => {
          if (error) {
            this.$root.$bvToast.toast(`Não foi possível atualizar a Lista de Ordens de Abate \n Tente Filtrar Manualmente!!!`, {
            title: 'Aviso',
            autoHideDelay: 2000,
            variant: 'warning',
            appendToast: true
          })
          this.$router.push(`/producao/ordemabate/listagem`)
          }
        })
      })
      .catch(erro => {
        this.$store.commit('controle/setAguardando', false)
        if (erro.response.status == 400) {
          this.toastCount++
          this.$root.$bvToast.toast(`Atenção: ${erro.response.data}`, {
            title: 'Atenção',
            autoHideDelay: 3000,
            variant: 'warning',
            appendToast: true
          })
        }
      })
    },
    onIniciarCadastramento () {
      if (!this.isValid()) {
        this.$root.$bvToast.toast(`Preencha todos os campos obrigatórios!!!`, {
          title: 'Aviso',
          autoHideDelay: 2000,
          variant: 'danger',
          appendToast: true
        })
        
        return
      }
      
      this.$store.commit('controle/setAguardando', true)    
      this.$http.post(`/api/protected/producao/post`, this.registro)
        .then((result) => {
          this.registro.ID = result.data.id
          this.registroMonitoramento = JSON.parse(JSON.stringify(this.registro))
          this.monitoraAlteracao = true

          this.$store.commit('controle/setAguardando', false)
          this.toastCount++
          this.$root.$bvToast.toast(`Dadas inicias cadastrados!!!`, {
            title: 'Aviso',
            autoHideDelay: 3000,
            variant: 'success',
            appendToast: true
          })
        })
        .then(() => {
          this.onAbrirModalAnimalNovo()
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          if (erro.response.status == 400) {
            this.toastCount++
            this.$root.$bvToast.toast(`Atenção: ${erro.response.data}`, {
              title: 'Atenção',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          }
        })
    },
    criarListasAnimal() {
      this.$http.get('api/protected/animalraca/listartodos')
      .then((data) => {
        if (data) {
          this.optionsRaca = []
          let i
          for (i = 0; i < data.data.length; i++) {
            this.optionsRaca.push({value: data.data[i].ID, text: data.data[i].NOME})
          }
        }
      }).catch((error) => {
        this.optionsRaca = []
      })
      this.$http.get('api/protected/animalcor/listartodos')
      .then((data) => {
        if (data) {
          this.optionsCor = []
          let i
          for (i = 0; i < data.data.length; i++) {
            this.optionsCor.push({value: data.data[i].ID, text: data.data[i].NOME})
          }
        }
      }).catch((error) => {
        this.optionsCor = []
      })
    },
    getRegistroById(id) {
      return new Promise(resolve => {
        this.$http.get(`/api/protected/producao/getById/${id}`)
        .then((result) =>{
          resolve(result)
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          if (erro.response.status == 400) {
            this.toastCount++
            this.$root.$bvToast.toast(`Atenção: ${erro.response.data}`, {
              title: 'Atenção',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          }
          resolve(false)
        })
      })
        
    },
    async iniciarAlteracao(id) {
      this.desabilitado = false
      let reg = await this.getRegistroById(id)
      
      if (reg == null || !reg.data) {
        this.$store.commit('controle/setAguardando', false)
        this.$bvToast.toast(`Falha ao localizar a Ordem de Abate!!`, {
          title: 'Erro',
          autoHideDelay: 5000,
          variant: 'warning',
          appendToast: true
        })
        this.$router.push(`/producao/ordemabate/listagem`)
        return
      }
      
      const data = reg.data
      
      // Formatação de datas e horas para os inputs
      if (data.DT_LOTE) data.DT_LOTE = moment(data.DT_LOTE).format('YYYY-MM-DD')
      if (data.DT_LANCAMENTO) data.DT_LANCAMENTO = moment(data.DT_LANCAMENTO).format('YYYY-MM-DD')
      if (data.DT_ALTERACAO) data.DT_ALTERACAO = moment(data.DT_ALTERACAO).format('YYYY-MM-DD')
      if (data.HORA_ENT) data.HORA_ENT = moment(data.HORA_ENT).format('HH:mm:ss')
      if (data.HORA_SAI) data.HORA_SAI = moment(data.HORA_SAI).format('HH:mm:ss')
      
      // Atualiza o objeto registro mantendo a reatividade
      this.registro = { ...this.registro, ...data }
      
      this.$nextTick(() => {
        if (this.$refs.pesquisaFornecedor) this.$refs.pesquisaFornecedor.atualizaComplete()
        if (this.$refs.pesquisaMarchante) this.$refs.pesquisaMarchante.atualizaComplete()
        if (this.$refs.pesquisaFazenda) this.$refs.pesquisaFazenda.atualizaComplete()
      })

      this.tabelaAnimais.items = []

      if (await this.atualizarListaAnimal() == true) {
        this.toastCount++
        this.$root.$bvToast.toast(`Ordem de Abate disponível para alterações`, {
          title: 'Atenção',
          autoHideDelay: 3000,
          variant: 'success',
          appendToast: true
        })
      } else {
        this.$store.commit('controle/setAguardando', false)
        this.$router.push(`/producao/ordemabate/listagem`)
        return
      }
   
      // CONTROLA ALTERACOES PARA O BOTAO ALTERAR
      this.registroMonitoramento = JSON.parse(JSON.stringify(this.registro))
      this.monitoraAlteracao = true
      this.itensForamAlterados = false

      this.$store.commit('controle/setAguardando', false)
    },
    compararObjeto (a, b) {
      if ((a == []) && (b == [])) {
        return true
      }
      let prop1
      try {
        prop1 = Object.getOwnPropertyNames(a)
      } catch (ex) {
        try {
          Object.getOwnPropertyNames(b)
        } catch (exx) {
          return true
        }
        return false
      }
       
      for (var i = 0; i < prop1.length; i++) {
        var prop = prop1[i]
        if ((prop.indexOf("__ob__") == -1) && (a[prop] != b[prop])) {
          return false
        }
      }
      return true
    },
    limparObjeto (a) {
      let prop1 = Object.getOwnPropertyNames(a)
      for(var i = 0; i < prop1.length; i++) {
        var prop = prop1[i]
        if ((prop.indexOf("__ob__") == -1) ) {
          a[prop] = null
        }
      }
    }
  },
  created () {
    // nao monitorar o botao gravar
    this.monitoraAlteracao = false
    this.registroMonitoramento = []

    let id = this.$route.params.id
    //ALTERACAO
    if ( id ) {
      this.iniciarAlteracao(id)
      
    } 
    //NOVO REGISTRO
    else {
      this.desabilitado = false
      this.$http.get(`/api/protected/producao/getIniciarForm`)
      .then(result => {
          let registroVazio = JSON.parse(JSON.stringify(this.registro))
          registroVazio.DT_LOTE                   = moment(new Date()).format('YYYY-MM-DD')
          registroVazio.DT_LANCAMENTO             = moment(new Date()).format('YYYY-MM-DD')
          registroVazio.HORA_ENT                  = moment(new Date()).format('HH:mm:ss')
          registroVazio.CENTRO_ESTOQUE_ID         = result.data[0].CENTRO_ESTOQUE_ID
          registroVazio.CUSTO_OPERACIONAL_ID      = result.data[0].CUSTO_OPERACIONAL_ID
          registroVazio.HORA_SAI                  = moment(new Date()).format('HH:mm:ss')
          registroVazio.VL_CUSTO_OPERACIONAL      = 0.00
          registroVazio.VINCULA_COMPRA_GADO       = result.data[0].VINCULA_COMPRA_GADO
          registroVazio.OP_TIPO_SERVICO           = result.data[0].OP_TIPO_SERVICO
          registroVazio.STATUS                    = result.data[0].STATUS

          this.registro = registroVazio

          this.tabelaAnimais.items = []

          return


      })
      .then(() =>{
        this.$http.get(`/api/protected/producao/getNovoNumeroLote`)
        .then(result => {
          this.registro.LOTE = result.data
        })
        .catch(err => {
        this.$bvToast.toast(`Não foi possível encontrar o próximo NÚMERO DO LOTE!! ${err}`, {
          title: 'Erro',
          autoHideDelay: 5000,
          variant: 'danger',
          appendToast: true
        })
        this.registro.LOTE = 1
      })
      })
      .catch(err => {
        this.$bvToast.toast(`Falha ao iniciar o Formulário de Ordem de Abate!! ${err}`, {
          title: 'Erro',
          autoHideDelay: 5000,
          variant: 'danger',
          appendToast: true
        })
        this.$router.push(`/producao/ordemabate/listagem`)
      })
    }
  },
  computed: {
    exibirBotaoAlterar: function() {
      // Se o registro já tem ID (foi salvo) e itens foram alterados, exibe o botão
      if (this.registro.ID && this.itensForamAlterados) {
        return true
      }
      
      // Caso contrário, verifica se está monitorando alterações no registro principal
      if (this.monitoraAlteracao == true) {
        return   !this.compararObjeto(this.registro, this.registroMonitoramento)
             ||  this.itensForamAlterados
      } else {
        return false
      }
    },
    exibirBotaoGravar: function () {
      return !this.registro.ID > 0
    },
    traduzStatus : function () {
      if (this.registro.STATUS == null) return ''
      switch (this.registro.STATUS) {
        case  '0' : return 'CANCELADA'
        case  '1' : return 'LANCAMENTO PRINCIPAIS' 
        case  '2' : return 'PLANEJAMENTO CONCLUIDO' 
        case  '3' : return 'PRONTO PARA COLETA' 
        case  '4' : return 'COLETA INICIADA' 
        case  '5' : return 'COLETA ENCERRADA'     
        case  '6' : return 'FECHADO' 
        case  '7' : return 'PAUSA' 
        default:
          break;
      }
    }
  }
}
</script>


<style>
  .card-header .card-alinha {
    position: absolute;
    top: 0;
    right: 0;
    
  }

 .card-header .card-alinha button {
    display: block;
    float: left;
    padding: 0.75rem 1rem;
    margin: 0 !important;
    
    text-align: center;
    
    border: 0;
    border-left: 1px solid #a4b7c1;
    -webkit-box-shadow: 0;
    box-shadow: 0;
 }

</style>


// WEBPACK FOOTER //
// src/views/producao/ordemabate/OrdemAbateCadastro.vue